module.exports = __webpack_public_path__ + "static/img/dianxin.fd22feb.png";


//////////////////
// WEBPACK FOOTER
// ./static/dianxin.png
// module id = T6C6
// module chunks = 1